// https://vuex.vuejs.org/en/mutations.html

export default {
  refreshUsers(state, users) {
    state.list = users;
  },
  UpdateUser (state, user) {
    var existingElementIndex
    state.list.some((el, index) => {
      if (el.uid === user.uid) {
        existingElementIndex = index
        return true
      }
    })
    if (existingElementIndex > -1) {
      state.list.splice(existingElementIndex, 1, user)
    } else {
      state.list.push(user)
    }
  },
};
